import { makeAdSupportedGamePolicy } from './game-ads'

/**
 * 소울웰드 — 융합 직업 핵앤슬래시 로그라이크. 무료 + AdMob 광고 + 광고 제거 인앱결제.
 *
 * **하루 만에 골격을 갈아탔다 (2026-08-25).** 아침에 이 파일은 `game-offline.ts`(수집 0)를
 * 썼다 — 그때 소울웰드는 ₩6,600 유료 단품 가설이었고, 게임에 광고 SDK 도 결제도 없다는
 * 것을 실측으로 확인하고 고른 골격이었다. 같은 날 사용자가 **무료 + 광고**로 판정을 뒤집어
 * 게임에 AdMob·RevenueCat 을 배선하면서, 그 골격의 "아무것도 기기를 떠나지 않는다"가
 * 그 자리에서 거짓이 됐다.
 *
 * **조항을 더하지 않고 골격을 바꾼 이유가 그것이다** (docs/privacy-policy.md §절대 규칙 2).
 * game-offline 골격은 무권한·무전송·광고 SDK 없음을 문장으로 주장하므로, 광고를 붙인 뒤
 * 거기에 광고 조항만 덧붙이면 한 문서 안에서 앞뒤가 어긋난다. 오마주 3종이 2026-08-24 에
 * 정확히 같은 경로를 밟았고, 이 파일은 그 선례를 따른다.
 *
 * 시행일을 August 25 하나로 둔 이유: 광고 없는 판이 스토어에 나간 적이 없다. 이 방침이
 * 이용자에게 닿는 첫 판은 광고가 붙은 판이다. 다만 그날 안에 방침 내용이 실제로 바뀐 것은
 * 사실이므로 개정 이력에 두 줄을 남긴다 — 웹에 잠깐 떠 있었던 판이 있다.
 */
export const SOULWELD_POLICY = makeAdSupportedGamePolicy({
  slug: 'soulweld',
  title: 'Soulweld Privacy Policy',
  name: 'Soulweld',
  storedOnDevice:
    'Your souls and heart pieces, how many runs you have played and how many you have won, the deepest floor you have reached, which fusion classes you have discovered, your bonds and farewells with the spirits, your ascension progress, whether you have seen the ending, whether you bought the ad removal, and your sound and music volume are the only things the app keeps.',
  removeAdsProductId: 'com.cottonray.soulweld.remove_ads',
  effectiveDate: 'August 25, 2026',
  lastRevisedDate: 'August 25, 2026',
  history: [
    'August 25, 2026 — established. The first published version described a game that collected nothing at all: it had no advertising, no in-app purchase, and no network access, and it was written for a paid one-off release',
    'August 25, 2026 — replaced on the same day, before the game reached any store, when the release was changed to a free, ad-supported one. Advertising through Google AdMob (a banner during play and one interstitial when a run ends) and a one-off in-app purchase that removes them were added to the game, so this policy was rewritten rather than amended: the earlier statement that nothing left your device stopped being true. What the app keeps on your device did not change apart from the record of that purchase',
    'August 25, 2026 — the banner ad was removed again on the same day, before the game reached any store, leaving one interstitial ad when a run ends as the only advertising. Less is now collected, not more: no ad is requested while you play. Who the data is entrusted to and where it is transferred did not change',
    'August 25, 2026 — the banner ad returned on the same day, now in a strip the game leaves empty before it draws itself, so the banner sits beside the game instead of over it. What is collected and who it goes to are the same as when the banner was there before: an advertising request while you play as well as at a game over. Who the data is entrusted to and where it is transferred did not change',
  ],
})
